<template>
  <nav aria-label="breadcrumb">
    <ol
      class="px-0 pt-1 pb-0 mb-0 bg-transparent breadcrumb"
      :class="this.$store.state.isRTL ? '' : ' me-sm-6'"
    >
      <li class="text-sm breadcrumb-item">
        <a href="/" class="opacity-3 text-dark">
          <font-awesome-icon :icon="faHouse" :class="textWhite" />
        </a>
      </li>
      <li class="text-sm breadcrumb-item" :class="textWhite">
        <a
          v-if="this.$store.state.isRTL"
          :class="textWhite"
          class="opacity-5 ps-2"
          href="#"
          >لوحات القيادة</a
        >
        <a v-else :class="textWhite" class="opacity-4" @click="home(currentDirectory)">{{
          currentDirectory
        }}</a>
      </li>
      <li
        class="text-sm breadcrumb-item active"
        :class="textWhite ? 'text-white' : 'text-dark'"
        aria-current="page"
      >
        {{ currentPage }}
      </li>
    </ol>
    
  </nav>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import router from '../router/index';

export default {
  name: "Breadcrumbs",
  components: {
    FontAwesomeIcon,
  },
  props: {
    currentPage: {
      type: String,
      default: "",
    },
    currentDirectory: {
      type: String,
      default: "",
    },
    textWhite: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      faHouse,
    };
  },
  methods:{
    home(currentDirectory){
      switch (currentDirectory) {
        case "Usuario":
            router.push({name: 'Consultar Usuarios'})
          break;
        case "Método":
            router.push({name: 'Consultar Métodos'})
          break;
        case "Unidad":
            router.push({name: 'Consultar Unidades'})
          break;
        case "Ruta":
            router.push({name: 'Consultar Rutas'})
          break;
        case "Viaje":
            router.push({name: 'Consultar Viajes'})
          break;
        case "Apertura":
            router.push({name: 'Consultar Aperturas'})
          break;
        default:
          break;
      }
    }
  }
};
</script>
